import { Api } from '../../../api';
import { errorToast, useOutsideClick, successToast } from '../../../utils/helper';
import Table from '../../../component/common/Table';
import React, { Fragment } from 'react';
import { useRef, useState, useEffect } from 'react';
import { Calendar } from 'react-date-range';
import SearchInput from '../../../component/common/Input/SearchInput';
import { Helmet } from 'react-helmet';
import { PER_PAGE } from '../../../utils/constants';
import { ChevronRightIcon, ChevronLeftIcon } from '@heroicons/react/20/solid';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import Loader from '../../../component/common/Loader';
import Topbar2 from '../../PulseSurvey/Topbar';
import Pagination from '../../../component/common/Pagination/Pagination';
import DashboardInfoCard from '../../../component/common/DashboardInfoCard';
import ChallengesCard from '../../../component/common/cards/ChallengesCard';
import { ApiForRole } from './ApiForRole';


function ViewChallenges() {
  const location = useLocation();
  // const { userType, companyId } = JSON.parse(localStorage.getItem('userData'));
  const selectedTheme = JSON.parse(localStorage.getItem('selectedTheme'));
  //const ref1 = useRef(null);
  const ref2 = useRef(null);
  const calendarRef = useRef(null);
  const [isOpen2, setIsOpen2] = useState(false);
  // const [showCalendar, setShowCalendar] = useState(false);
  const [startDate, setStartDate] = useState();
  const [numberError, setNumberError] = useState('');
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortOrder, setSortOrder] = useState('desc');
  const [sortBy, setSortBy] = useState('');
  const [filterQuery, setFilterQuery] = useState('');
  const [selectedPerPage, setSelectedPerPage] = useState(PER_PAGE[0]);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [orderTypeis0, setorderTypeis0] = useState(null);

  const [totalCompaniesInsights, settotalCompaniesInsights] = useState(0);
  const [activeUsersInsights, setactiveUsersInsights] = useState(0);
  const [freeSeatsInights, setfreeSeatsInights] = useState(0);
  const [debounceTimeout, setDebounceTimeout] = useState(null);

  const [filterCriteria, setFilterCriteria] = useState({
    companySubscription: ''
  });

  const [challengesList, setChallengesList] = useState({
    stats: {
      activeChallengesCount: 0,
      totalChallengesCount: 0,
      totalTasksInChallenges: 0
    },
    challenges: [],
    pagination: {
      totalCount: 5,
      totalPages: 1,
      currentPage: 1,
      limit: 10
    }
  });

  const pages = [{ name: 'Marketplace', href: '/marketplace', current: true }];
  const columns = [
    {
      title: '',
      key: 'profile',
      sortable: false,
      type: 'profile',
      align: 'left',
      //rowClassName: '!text-base font-medium w-[250px]'
      width: 250,
      style: {
        opacity: 'opacity-100'
      }
    },
    {
      title: 'Offer Title',
      key: 'offerTitle',
      sortable: false,
      type: 'text',
      align: 'left',
      rowClassName: '!text-base font-medium'
    },
    {
      title: 'Offer Description',
      key: 'offerDescription',
      sortable: false,
      sortKey: 'companyDescription',
      type: 'text',
      align: 'left'
    },

    {
      title: 'Discount Rate',
      key: 'discountRate',
      sortable: false,
      //   sortKey: 'company_subscription',
      type: 'text',
      align: 'center'
    },
    {
      title: 'Redeem Time',
      key: 'redeemTime',
      sortable: false,
      //   sortKey: 'company_subscription',
      type: 'text',
      align: 'center'
    },
    {
      title: 'Code',
      key: 'code',
      sortable: false,
      type: 'text',
      align: 'center'
    },
    {
      title: 'Click Count',
      key: 'clickCount',
      sortable: false,
      //   sortKey: 'company_subscription',
      type: 'text',
      align: 'center'
    },
    {
      title: 'Created At',
      key: 'createdAt',
      sortable: false,
      //   sortKey: 'company_subscription',
      type: 'date',
      align: 'left'
    },
    {
      title: 'Status',
      key: 'isExpired',
      sortable: false,
      //   sortKey: 'company_subscription',
      type: 'text',
      align: 'center'
    },
    {
      title: 'View Insights',
      key: 'viewInsights',
      type: 'text',
      // sortable: false,
      //   sortKey: 'company_subscription',
      align: 'center'
      //isView: '/content-management/meditation/view'
    },
    {
      title: '',
      key: 'action',
      type: 'action',
      align: 'left',
      isEdit: true,
      handleEdit: (rowData) => {
        navigate(
          `/marketplace/create-new-company-offer?page=editoffers&offerid=${rowData?._id}`
          // ,{
          //   state: { ...rowData, action: 'edit' }
          // }
        );

        // setAddPodExpertsStates({
        //   fullName: rowData?.name,
        //   description: rowData?.description,
        //   image: rowData?.image
        // });
        // setPreview(rowData?.image);
        // setSelectedId(rowData?.id);
      },
      isDelete: true
    }
  ];

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const offerParam = queryParams.get('type');

    let orderType = null;
    if (offerParam === 'challenges') {
      orderType = 2;
    } else if (offerParam === 'active') {
      orderType = 0;
    } else if (offerParam === 'templates') {
      orderType = 1;
    }

    setorderTypeis0(orderType);

    handlePagination(1, selectedPerPage?.value, sortBy, sortOrder, orderType, searchTerm);
  }, [location.search]);

  const handlePagination = (
    pageNumber,
    pageSize,
    sortByKey,
    orderByKey,
    offerType,
    searchKey
    // startDate = '',
    // endDate = ''
  ) => {
    setLoader(true);

    if (sortByKey === '') sortByKey = 'createdAt';
    //if (orderByKey === '') orderByKey = 'desc';

    // Api.getMarketplaceOffersList(pageNumber, pageSize, sortByKey, orderByKey, offerType, searchKey)
    //   .then((response) => {
    //     setLoader(false);
    //     //console.log('Real data from the real data x3 API', response?.data?.data?.data);
    //     if (response?.data) {
    //       if (response?.data?.data) {
    //         setUsersList(
    //           response?.data?.data?.data?.map(({ offerImages, ...rest }) => ({
    //             ...rest,
    //             profile: offerImages?.length > 0 ? offerImages[0] : null,
    //             viewInsights: 'view'
    //           }))
    //         );

    //         setCurrentPage(pageNumber);
    //         setTotalCount(response?.data?.data?.pagination?.totalCount);
    //         setLoader(false);
    //       } else {
    //         setLoader(false);
    //         errorToast('Something went wrong, please try again later !');
    //       }
    //     } else if (response?.data?.meta?.code === 401) {
    //       errorToast(response?.message);
    //       setLoader(false);
    //     } else if (response?.data?.meta?.code === 0) {
    //       setLoader(false);
    //       setCurrentPage(1);
    //       setUsersList([]);
    //       setTotalCount(0);
    //       errorToast(response?.data?.meta?.message);
    //     } else {
    //       setLoader(false);
    //     }
    //   })
    //   .catch((error) => {
    //     console.log('error we got after the Get Companies API call', error);
    //   })
    //   .finally(() => {
    //     setLoader(false);
    //   });

    // HERE WE NEED TO MAKE THE API CAL FOR THE MARKETPLACE INSIGHTS
    // Api.getInstantSupportInsights()
    //   .then((response) => {
    //     settotalCompaniesInsights(response?.data?.data?.totalCompanies);
    //     setactiveUsersInsights(response?.data?.data?.customTypeCompanies);
    //     setfreeSeatsInights(response?.data?.data?.otherTypesCompanies);
    //   })
    //   .catch((error) => {
    //     console.log('error we got after the status change API call', error);
    //   })
    //   .finally(() => {
    //     setLoader(false);
    //   });
  };

  useEffect(() => {
    // We'll only set up the debounce cleanup
    return () => {
      if (debounceTimeout) clearTimeout(debounceTimeout);
    };
  }, []);

  // This handlePerPage is not being used in this table
  const handlePerPage = (perPage) => {
    setSelectedPerPage(perPage);
    handlePagination(1, perPage.value, sortBy, sortOrder, orderTypeis0, searchTerm);
  };

  const refreshTable = () => handlePagination(1, selectedPerPage?.value, '', sortBy, sortOrder);

  const resetHandler = () => {
    setFilterCriteria({
      companySubscription: ''
    });
    setFilterQuery('');
    setShowFilterModal(false);
    handlePagination(1, selectedPerPage.value, searchTerm, sortBy, sortOrder, orderTypeis0, '');
  };

  const handleChangeC = (e) => {
    const date = new Date(e);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    setStartDate(formattedDate);
    handlePagination(1, selectedPerPage.value, sortBy, sortOrder, orderTypeis0, searchTerm);
    setIsOpen2(false);
  };

  // useRef to handle click outside the Date range calandar
  useOutsideClick(calendarRef, () => {
    setIsOpen2(false);
  });

  const deleteHandler = (_id) => {
    setLoader(true);
    setSearchTerm('');
    //console.log("what is this ID ?", _id);
    ApiForRole().delMarketplaceOffer(_id).then((response) => {
      if (response?.data?.meta?.code === 200) {
        handlePagination(1, selectedPerPage?.value, sortBy, sortOrder, orderTypeis0, '');
        successToast(response?.data?.meta?.message ?? 'Company deleted successfully');
      } else if (response?.data?.meta?.code === 0) {
        setLoader(false);
        errorToast(
          response?.data?.meta?.message ?? 'Something went wrong while deleting the company'
        );
      } else {
        setLoader(false);
      }
    });
  };

  const rowsData = usersList.map((item) => {
    return {
      ...item,
      offerTitle: (
        <>
          <div>
            {item.offerTitle
              ? item.offerTitle
                  .split(' ')
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                  .join(' ')
              : ''}
          </div>
        </>
      ),
      isExpired: (
        <>
          <div
            className={`w-24 h-6 flex items-center justify-center text-center text-xs rounded-full border appearance-none
              ${
                new Date(item?.expiryDate) < new Date()
                  ? 'bg-[#F9F2F5] text-[#BF3261] border-[#BF3261]'
                  : 'bg-[#DDF2BF] text-[#438038] border-[#438038]'
              }`}
          >
            {new Date(item?.expiryDate) < new Date() ? 'Expired' : 'Active'}
          </div>
        </>
      ),
      viewInsights: (
        <button
          className="w-24 h-6 flex items-center justify-center text-center text-xs bg-shoorah-secondary/10 border-shoorah-secondary text-shoorah-secondary hover:bg-shoorah-secondary/20 rounded-full border appearance-none"
          onClick={() => {
            navigate(`/marketplace/create-new-company-offer?page=insights&offerid=${item?._id}`);
          }}
        >
          {item?.viewInsights || 'View Insights'}
        </button>
      )
    };
  });

  const subAdminStatusCards = [
    <DashboardInfoCard
      icon={
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20.4131 10.1069L20.762 11.2385L21.8935 11.5874C23.3969 12.0511 25.0334 11.6451 26.1457 10.5327L28.1581 8.52031C29.2192 10.5618 29.7702 13.0727 29.7702 16.012C29.7702 24.833 24.8083 29.7949 15.9874 29.7949C7.16639 29.7949 2.20459 24.833 2.20459 16.012C2.20459 7.19106 7.16639 2.22925 15.9874 2.22925C18.9274 2.22925 21.4386 2.78043 23.4804 3.84197L21.4677 5.85472C20.3553 6.96714 19.9494 8.60357 20.4131 10.1069Z"
            fill="#B6C0F3"
          />
          <path
            d="M29.7702 16.012C29.7702 24.833 24.8083 29.7949 15.9874 29.7949C7.16639 29.7949 2.20459 24.833 2.20459 16.012C2.20459 7.19106 7.16639 2.22925 15.9874 2.22925"
            stroke="#313B6B"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M13.7821 9.07458C10.5821 9.80083 8.82031 12.2209 8.82031 16.0112C8.82031 20.5981 11.4005 23.1782 15.9874 23.1782C19.9638 23.1782 22.4319 21.2392 23.0187 17.7347"
            stroke="#313B6B"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M15.9873 16.011L20.7639 11.2344"
            stroke="#313B6B"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M20.7619 11.2385L20.413 10.1069C19.9494 8.60355 20.3552 6.96712 21.4676 5.85471L25.117 2.20514L26.2197 5.78055L29.7951 6.88317L26.1456 10.5327C25.0334 11.6451 23.3969 12.0511 21.8935 11.5874L20.7619 11.2385Z"
            fill="white"
          />
          <path
            d="M20.7619 11.2385L20.413 10.1069C19.9494 8.60355 20.3552 6.96712 21.4676 5.85471L25.117 2.20514L26.2197 5.78055L29.7951 6.88317L26.1456 10.5327C25.0334 11.6451 23.3969 12.0511 21.8935 11.5874L20.7619 11.2385Z"
            stroke="#313B6B"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      }
      title={'Active Challenges'}
      value={challengesList?.stats?.activeChallengesCount || 0}
    />,
    <DashboardInfoCard
      icon={
        <svg
          width="56"
          height="56"
          viewBox="0 0 56 56"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="56" height="56" rx="28" fill="#E5EAF9" />
          <path
            d="M14.7346 29.4039C14.0289 28.5829 14.0285 27.3712 14.7339 26.55C15.2389 25.9621 15.7447 25.3846 16.2527 24.8163C16.0991 24.0795 15.9516 23.3358 15.8097 22.5832C15.6091 21.5194 16.2145 20.4699 17.2361 20.1113C17.9673 19.8547 18.6941 19.6075 19.4182 19.3693C19.6535 18.6545 19.8977 17.9366 20.1511 17.2139C20.5093 16.1922 21.5584 15.5861 22.6223 15.7864C23.371 15.9273 24.1114 16.074 24.8452 16.2269C25.4042 15.7276 25.9721 15.2303 26.55 14.7339C27.3712 14.0285 28.5829 14.0289 29.4039 14.7346C29.9847 15.2338 30.5551 15.7334 31.1163 16.2348C31.8625 16.0791 32.6156 15.9297 33.3771 15.7864C34.4411 15.5861 35.4901 16.1922 35.8484 17.2139C36.1018 17.9366 36.3458 18.6545 36.5812 19.3693C37.3053 19.6075 38.0322 19.8547 38.7633 20.1113C39.785 20.4699 40.3905 21.5193 40.1897 22.5832C40.0454 23.3487 39.8953 24.1051 39.7389 24.8542C40.2491 25.4249 40.7574 26.005 41.2653 26.596C41.9709 27.417 41.9714 28.6286 41.2659 29.4499C40.7608 30.0378 40.2551 30.6154 39.747 31.1839C39.9004 31.9205 40.0481 32.6642 40.1899 33.4168C40.3905 34.4808 39.785 35.5302 38.7635 35.8887C38.0322 36.1455 37.3053 36.3927 36.581 36.6308C36.3456 37.3456 36.1015 38.0636 35.8481 38.7862C35.4899 39.8079 34.4409 40.414 33.377 40.2137C32.6284 40.0728 31.8881 39.9261 31.1544 39.7733C30.5954 40.2725 30.0277 40.7697 29.4499 41.2659C28.6286 41.9714 27.417 41.9709 26.596 41.2653C26.0152 40.7661 25.4449 40.2665 24.8837 39.7652C24.1373 39.921 23.3842 40.0702 22.6225 40.2137C21.5586 40.414 20.5094 39.8079 20.1512 38.7862C19.8979 38.0636 19.6537 37.3456 19.4184 36.6308C18.6942 36.3925 17.9673 36.1455 17.2359 35.8887C16.2144 35.5302 15.6089 34.4808 15.8095 33.4168C15.9539 32.6511 16.1041 31.8945 16.2606 31.1452C15.7505 30.5746 15.2423 29.9947 14.7346 29.4039Z"
            fill="#B6C0F3"
          />
          <path
            d="M14.7346 29.4039C14.0289 28.5829 14.0285 27.3712 14.7339 26.55C15.2389 25.9621 15.7447 25.3846 16.2527 24.8163C16.0991 24.0795 15.9516 23.3358 15.8097 22.5832C15.6091 21.5194 16.2145 20.4699 17.2361 20.1113C17.9673 19.8547 18.6941 19.6075 19.4182 19.3693C19.6535 18.6545 19.8977 17.9366 20.1511 17.2139C20.5093 16.1922 21.5584 15.5861 22.6223 15.7864C23.371 15.9273 24.1114 16.074 24.8452 16.2269C25.4042 15.7276 25.9721 15.2303 26.55 14.7339C27.3712 14.0285 28.5829 14.0289 29.4039 14.7346C29.9847 15.2338 30.5551 15.7334 31.1163 16.2348C31.8625 16.0791 32.6156 15.9297 33.3771 15.7864C34.4411 15.5861 35.4901 16.1922 35.8484 17.2139C36.1018 17.9366 36.3458 18.6545 36.5812 19.3693C37.3053 19.6075 38.0322 19.8547 38.7633 20.1113C39.785 20.4699 40.3905 21.5193 40.1897 22.5832C40.0454 23.3487 39.8953 24.1051 39.7389 24.8542C40.2491 25.4249 40.7574 26.005 41.2653 26.596C41.9709 27.417 41.9714 28.6286 41.2659 29.4499C40.7608 30.0378 40.2551 30.6154 39.747 31.1839C39.9004 31.9205 40.0481 32.6643 40.1899 33.4168C40.3905 34.4808 39.785 35.5302 38.7635 35.8887C38.0322 36.1455 37.3053 36.3927 36.581 36.6308C36.3456 37.3456 36.1015 38.0636 35.8481 38.7862C35.4899 39.8079 34.4409 40.414 33.377 40.2137C32.6284 40.0728 31.8881 39.9261 31.1544 39.7733C30.5954 40.2725 30.0277 40.7697 29.4499 41.2659C28.6286 41.9714 27.417 41.9709 26.596 41.2653C26.0152 40.7661 25.4449 40.2665 24.8837 39.7652C24.1373 39.921 23.3842 40.0702 22.6225 40.2137C21.5586 40.414 20.5094 39.8079 20.1512 38.7862C19.8979 38.0636 19.6537 37.3456 19.4184 36.6308C18.6942 36.3925 17.9673 36.1455 17.2359 35.8887C16.2144 35.5302 15.6089 34.4808 15.8095 33.4168C15.9539 32.6511 16.1041 31.8945 16.2606 31.1452C15.7505 30.5746 15.2423 29.9947 14.7346 29.4039Z"
            stroke="#313B6B"
            stroke-width="2.288"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M23.3516 29.1621L26.7321 32.6482C28.3228 28.0787 29.6476 26.0736 32.648 23.3518"
            stroke="#313B6B"
            stroke-width="2.288"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      }
      title={'Total Challenges'}
      value={challengesList?.stats?.totalChallengesCount || 0}
    />,
    <DashboardInfoCard
      icon={
        <svg
          width="56"
          height="56"
          viewBox="0 0 56 56"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="56" height="56" rx="28" fill="#E5EAF9" />

          <g transform="translate(12, 12)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.5848 18.458C4.83034 13.717 -1.46276 2.2043 16.0011 2.2043C33.4632 2.2043 27.1731 13.7145 23.4186 18.4564C22.7044 16.4418 21.2808 15.0534 19.233 14.377C20.277 12.4681 20.8045 10.9997 20.9888 9.45708C19.0618 9.06947 17.5451 8.90068 16.0011 8.92167C14.4571 8.90068 12.9404 9.06947 11.0135 9.45708C11.1978 10.9999 11.7253 12.4683 12.7695 14.3775C10.7219 15.0543 9.29852 16.4429 8.5848 18.458Z"
              fill="#B6C0F3"
            />
            <path
              d="M8.5848 18.458C4.83034 13.717 -1.46276 2.2043 16.0011 2.2043C33.4632 2.2043 27.1731 13.7145 23.4186 18.4564C22.7044 16.4418 21.2808 15.0534 19.233 14.377C20.277 12.4681 20.8045 10.9997 20.9887 9.45708C19.0618 9.06947 17.5451 8.90068 16.0011 8.92167C14.4571 8.90068 12.9404 9.06947 11.0135 9.45708C11.1978 10.9999 11.7253 12.4683 12.7695 14.3775C10.7219 15.0543 9.29852 16.4429 8.5848 18.458Z"
              stroke="#313B6B"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M13.0774 2.33711C11.985 3.26416 10.6072 6.04124 11.0122 9.45734"
              stroke="#313B6B"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M18.9242 2.33711C20.0166 3.26416 21.3944 6.04124 20.9895 9.45734"
              stroke="#313B6B"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M16.0005 29.7945C21.0854 29.7945 23.9456 26.9343 23.9456 21.8494C23.9456 16.7645 21.0854 13.9043 16.0005 13.9043C10.9157 13.9043 8.05542 16.7645 8.05542 21.8494C8.05542 26.9343 10.9157 29.7945 16.0005 29.7945Z"
              fill="white"
            />
            <path
              d="M16.0005 29.7945C21.0854 29.7945 23.9456 26.9343 23.9456 21.8494C23.9456 16.7645 21.0854 13.9043 16.0005 13.9043C10.9157 13.9043 8.05542 16.7645 8.05542 21.8494C8.05542 26.9343 10.9157 29.7945 16.0005 29.7945Z"
              stroke="#313B6B"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M17.7084 19.6261C17.5931 19.1601 17.4453 18.7284 17.2583 18.3221C16.7521 17.2215 15.256 17.2213 14.7487 18.3213C14.5613 18.7279 14.413 19.1598 14.2977 19.6261C13.8458 19.61 13.4107 19.6257 12.9853 19.6763C11.7614 19.8219 11.2612 21.2567 12.1748 22.084C12.4933 22.3724 12.847 22.6326 13.243 22.8718C13.0981 23.2674 12.9868 23.659 12.9071 24.0522C12.6562 25.2897 13.9036 26.232 14.994 25.5949C15.3407 25.3925 15.6745 25.1548 16.002 24.8778C16.3298 25.1552 16.6643 25.3931 17.0118 25.5958C18.1026 26.232 19.3499 25.2897 19.099 24.0522C19.0193 23.659 18.908 23.2674 18.763 22.8718C19.159 22.6326 19.5128 22.3724 19.8313 22.084C20.7449 21.2567 20.2446 19.8219 19.0208 19.6763C18.5954 19.6257 18.1603 19.61 17.7084 19.6261Z"
              fill="#B6C0F3"
            />
            <path
              d="M17.7084 19.6261C17.5931 19.1601 17.4453 18.7284 17.2583 18.3221C16.7521 17.2215 15.256 17.2213 14.7487 18.3213C14.5613 18.7279 14.413 19.1598 14.2977 19.6261C13.8458 19.61 13.4107 19.6257 12.9853 19.6763C11.7614 19.8219 11.2612 21.2567 12.1748 22.084C12.4933 22.3724 12.847 22.6326 13.243 22.8718C13.0981 23.2674 12.9868 23.659 12.9071 24.0522C12.6562 25.2897 13.9036 26.232 14.994 25.5949C15.3407 25.3925 15.6745 25.1548 16.002 24.8778C16.3298 25.1552 16.6643 25.3931 17.0118 25.5958C18.1026 26.232 19.3499 25.2897 19.099 24.0522C19.0193 23.659 18.908 23.2674 18.763 22.8718C19.159 22.6326 19.5128 22.3724 19.8313 22.084C20.7449 21.2567 20.2446 19.8219 19.0208 19.6763C18.5954 19.6257 18.1603 19.61 17.7084 19.6261Z"
              stroke="#313B6B"
              stroke-width="2"
              stroke-linejoin="round"
            />
          </g>
        </svg>
      }
      title={'Created Tasks'}
      value={challengesList?.stats?.totalTasksInChallenges || 0}
    />
  ];

  const [activeOfferingsCardsData, setactiveOfferingsCardsData] = useState([
    {
      id: 1,
      title: 'Team Assessment Template1',
      usedBy: 12,
      type: 1,
      expiryDate: '2023-10-31',
      offerTitle: 'Performance Evaluation Form',
      coverImage: 'https://via.placeholder.com/178x178.png?text=Template+1',
      offerImages: 'https://via.placeholder.com/178x178.png?text=Template+2'
    },
    {
      id: 2,
      title: 'Performance Evaluation Form2',
      usedBy: 8,
      type: 2,
      expiryDate: '2023-10-31',
      offerTitle: 'Performance Evaluation Form',
      coverImage: 'https://via.placeholder.com/178x178.png?text=Template+2',
      offerImages: 'https://via.placeholder.com/178x178.png?text=Template+2'
    },
    {
      id: 3,
      title: 'Team Assessment Template3',
      usedBy: 12,
      type: 1,
      coverImage: 'https://via.placeholder.com/178x178.png?text=Template+1',
      offerImages: 'https://via.placeholder.com/178x178.png?text=Template+2'
    },
    {
      id: 4,
      title: 'Performance Evaluation Form4',
      usedBy: 8,
      type: 2,
      coverImage: 'https://via.placeholder.com/178x178.png?text=Template+2',
      offerImages: 'https://via.placeholder.com/178x178.png?text=Template+2'
    },
    {
      id: 5,
      title: 'Team Assessment Template5',
      usedBy: 12,
      type: 1,
      coverImage: 'https://via.placeholder.com/178x178.png?text=Template+1',
      offerImages: 'https://via.placeholder.com/178x178.png?text=Template+2'
    },
    {
      id: 6,
      title: 'Performance Evaluation Form6',
      usedBy: 8,
      type: 2,
      coverImage: 'https://via.placeholder.com/178x178.png?text=Template+2',
      offerImages: 'https://via.placeholder.com/178x178.png?text=Template+2'
    },
    {
      id: 1,
      title: 'Team Assessment Template1',
      usedBy: 12,
      type: 1,
      expiryDate: '2023-10-31',
      offerTitle: 'Performance Evaluation Form',
      coverImage: 'https://via.placeholder.com/178x178.png?text=Template+1',
      offerImages: 'https://via.placeholder.com/178x178.png?text=Template+2'
    },
    {
      id: 2,
      title: 'Performance Evaluation Form2',
      usedBy: 8,
      type: 2,
      expiryDate: '2023-10-31',
      offerTitle: 'Performance Evaluation Form',
      coverImage: 'https://via.placeholder.com/178x178.png?text=Template+2',
      offerImages: 'https://via.placeholder.com/178x178.png?text=Template+2'
    },
    {
      id: 3,
      title: 'Team Assessment Template3',
      usedBy: 12,
      type: 1,
      coverImage: 'https://via.placeholder.com/178x178.png?text=Template+1',
      offerImages: 'https://via.placeholder.com/178x178.png?text=Template+2'
    },
    {
      id: 4,
      title: 'Performance Evaluation Form4',
      usedBy: 8,
      type: 2,
      coverImage: 'https://via.placeholder.com/178x178.png?text=Template+2',
      offerImages: 'https://via.placeholder.com/178x178.png?text=Template+2'
    },
    {
      id: 5,
      title: 'Team Assessment Template5',
      usedBy: 12,
      type: 1,
      coverImage: 'https://via.placeholder.com/178x178.png?text=Template+1',
      offerImages: 'https://via.placeholder.com/178x178.png?text=Template+2'
    },
    {
      id: 6,
      title: 'Performance Evaluation Form6',
      usedBy: 8,
      type: 2,
      coverImage: 'https://via.placeholder.com/178x178.png?text=Template+2',
      offerImages: 'https://via.placeholder.com/178x178.png?text=Template+2'
    }
  ]);

  // const [loader, setLoader] = useState(false);

  const fetchList = async (id) => {
    setLoader(true);
    try {
      const response = await Api.getListChallenges(id)
        const responseData = response?.data || {};
        if (responseData) {
          setChallengesList(responseData);
        }
    } catch (error) {
      console.error('Error fetching get wellpoints count:', error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const offerParam = queryParams.get('type');

    let passId = null;
    if (offerParam === 'challenges') {
      passId = '';
    } else if (offerParam === 'active') {
      passId = 1;
    } else if (offerParam === 'templates') {
      passId = 0;
    }
    fetchList(passId);
  }, []);

  return (
    <>
      <div className="relative lg:ps-5 lg:mb-[45px]">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Marketplace | Shoorah Admin</title>
        </Helmet>
        {loader ? <Loader /> : null}
        <Topbar2
          title={
            orderTypeis0 === 0
              ? ' Active Challenges'
              : orderTypeis0 === 1
              ? 'Created Templates'
              : orderTypeis0 === 2
              ? ' Challenges'
              : ' Challenges'
          }
          infoBtn={true}
        />
      </div>

      <div className="relative lg:pl-5 lg:mb-[45px]">
        {/*search options, Date filter & Add Company are here */}
        <div className="sm:flex flex-col md:flex-row justify-between items-center gap-3">
          {/* Left-aligned search input */}
          <div className="flex items-center justify-center w-full sm:w-auto">
            <SearchInput
              id="searchKey"
              name="searchKey"
              type="text"
              onChange={(e) => {
                setSearchTerm(e.target.value);
                // Debouncing search input
                if (debounceTimeout) clearTimeout(debounceTimeout);
                const timeout = setTimeout(() => {
                  handlePagination(
                    1,
                    selectedPerPage?.value,
                    sortBy,
                    sortOrder,
                    orderTypeis0,
                    e.target.value
                  );
                }, 500);
                setDebounceTimeout(timeout);
              }}
              placeholder="Search"
              className="w-full sm:w-auto px-3 py-2"
            />
          </div>

          {/* Right-aligned buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center mt-2 sm:mt-0 space-y-2 sm:space-y-0 sm:space-x-2 w-full sm:w-auto">
            <div ref={ref2} className="relative inline-block text-left w-64 sm:w-auto">
              <button
                type="button"
                onClick={() => setIsOpen2(!isOpen2)}
                className="flex justify-between items-center w-full sm:w-auto px-5 py-2 text-xs sm:text-base font-medium border dark:border-text-shoorah-darkBg border-[#0B1D2E] rounded-full dark:text-shoorah-darkBg dark:border-shoorah-darkBg"
              >
                <span>
                  {startDate ? `${new Date(startDate).toLocaleDateString()}` : 'Date Created'}
                </span>
                {selectedTheme ? (
                  <>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.2802 9.9668L12.9335 14.3135C12.4202 14.8268 11.5802 14.8268 11.0669 14.3135L6.72021 9.9668"
                        stroke="#F3F4F6"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </>
                ) : (
                  <>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.2802 9.9668L12.9335 14.3135C12.4202 14.8268 11.5802 14.8268 11.0669 14.3135L6.72021 9.9668"
                        stroke="#0B1D2E"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </>
                )}
              </button>
              {isOpen2 && (
                <div
                  className="absolute sm:-top-2 top-0 md:-left-60 sm:-left-40 left-0 w-full sm:w-auto transform scale-90 sm:scale-100 z-10 mt-1 p-2 bg-white shadow-lg ring-1 ring-[#E7EAE8] dark:bg-shoorah-darkBgColor rounded-md"
                  ref={calendarRef}
                >
                  <div className="bg-white dark:bg-shoorah-darkBgColor text-[14px]">
                    <Calendar
                      className={'calendar text-sm sm:text-lg'}
                      onChange={handleChangeC}
                      nextLabel={
                        <button className="custom-next-button flex justify-center items-center">
                          <ChevronRightIcon className="w-8 h-8" />
                        </button>
                      }
                      maxDate={new Date()}
                      prevLabel={
                        <button className="custom-prev-button flex justify-center items-center">
                          <ChevronLeftIcon className="w-8 h-8" />
                        </button>
                      }
                      date={startDate ? new Date(startDate) : new Date()}
                      navigationLabel={({ date }) => (
                        <button
                          style={{ cursor: 'default', pointerEvents: 'none' }}
                          className="text-base"
                        >
                          {date.toLocaleDateString('en-US', { year: 'numeric', month: 'long' })}
                        </button>
                      )}
                    />
                  </div>
                </div>
              )}
            </div>

            {/* <div className="self-center inline-flex items-center justify-center w-64 sm:w-auto">
              <button
                className="inline-flex w-64 sm:w-auto text-base font-medium items-center justify-center rounded-3xl border bg-shoorah-secondary px-5 py-2 text-white shadow-sm hover:shoorah-primary focus:outline-none"
                onClick={() => {
                  navigate(`/marketplace/create-new-company-offer?page=createoffers`);
                }}
              >
                Add Offer
              </button>
            </div> */}
            <Link
              to={'/challenges/create-new-challenges?page=details'}
              className="font-medium px-5 py-2 bg-shoorah-active text-white rounded-full xl:text-[16px] text-[14px]"
            >
              Create New Challenge
            </Link>
          </div>
        </div>

        <div className="grid md:grid-cols-3 grid-cols-1 h-auto gap-4 mt-5">
          {subAdminStatusCards.map((item, index) => (
            <React.Fragment key={index}>{item}</React.Fragment>
          ))}
        </div>

        {/* <div className="lg:mt-5 flex flex-col">
          <div className="mt-4 w-full md:w-[100%]">
            <Table
              columns={columns}
              data={rowsData}
              name={'company_table'}
              setDeleteId={deleteHandler}
              bottomBorder={totalCount > selectedPerPage?.value}
              refreshTable={refreshTable}
              loader={loader}
            />
          </div>
        </div> */}

        <div className="lg:mt-8 flex flex-col">
          {orderTypeis0 === 0 && (
            <ChallengesCard
              title="Active Challenges"
              onViewAllTap={() => navigate('/challenges/view-challenges?type=active')}
              dataList={challengesList?.challenges}
              view={false}
            />
          )}
          {orderTypeis0 === 2 && (
            <ChallengesCard
              title="Challenges"
              onViewAllTap={() => navigate('/challenges/view-challenges?type=challenges')}
              dataList={challengesList?.challenges}
              preview={true}
              view={false}
            />
          )}
          {orderTypeis0 === 1 && (
            <ChallengesCard
              title="Created Templates"
              onViewAllTap={() => navigate('/challenges/view-challenges?type=templates')}
              dataList={challengesList?.challenges}
              preview={true}
              view={false}
            />
          )}
          {/* <HorizontalListCard
                    title="Most Popular Active Offers"
                    onViewAllTap={() => navigate('/marketplace/view-offers?offertype=popular')}
                    dataList={mostPopularActiveOffers}
                  />
                  <HorizontalListCard
                    title="Drafts"
                    onViewAllTap={() => navigate('/marketplace/view-offers?offertype=draft')}
                    dataList={draftOffers}
                  /> */}
        </div>

        <div>
          {usersList.length > 0 && !loader ? (
            <Pagination
              currentPage={currentPage}
              totalCount={totalCount}
              pageSize={selectedPerPage?.value}
              onPageChange={(page) => {
                handlePagination(
                  page,
                  selectedPerPage?.value,
                  sortBy,
                  sortOrder,
                  orderTypeis0,
                  searchTerm
                );
              }}
            />
          ) : (
            <span />
          )}
        </div>
      </div>
    </>
  );
}

export default ViewChallenges;
